module.exports = __webpack_public_path__ + "img/alentour26.fdd84b24.jpg";